import { render, staticRenderFns } from "./InstructionsPage.vue?vue&type=template&id=2aabcf97&"
import script from "./InstructionsPage.vue?vue&type=script&lang=ts&"
export * from "./InstructionsPage.vue?vue&type=script&lang=ts&"
import style0 from "./InstructionsPage.vue?vue&type=style&index=0&id=2aabcf97&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports